export default __webpack_public_path__ + "static/media/Privacy-Policy.1d23b1da.jpg";